import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();

$(function() {
	const testimonialSliderMain = {

		init: function() {
			this.testimonialSlider();
			this.readMoreFunction();
		},

		testimonialSlider: function() {
			const sliderConfig = {
				infinite: true,
				slidesToShow: 3,
				autoplay: false,
				speed: 500,
				dots: false,
				arrows: true,
				prevArrow: $('.js-testimonial-slider__arr-prev'),
				nextArrow: $('.js-testimonial-slider__arr-next'),
				cssEase: 'linear',
				fade: false,
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1
						}
					}
				]
			};

			sliders.initializeSlider('.js-testimonial-slider', sliderConfig);

			$(window).on('load resize', function() {
				$('.js-testimonial-slider').slick('setPosition');
			});
		},

		readMoreFunction: function() {

			const getCharLimit = () => {
				const w = window.innerWidth;
				if (w < 375) return 50;
				if (w < 575) return 70;
				if (w < 768) return 100;
				if (w < 1200) return 150;
				return 222;
			};

			const applyReadMore = () => {
				const charLimit = getCharLimit();

				$('.testimonial-slider__slider-box-inner-desc').each(function() {
					const $desc = $(this);

					const fullHtml = $desc.data('original-html') || $desc.html().trim();

					if (!$desc.data('original-html')) {
						$desc.data('original-html', fullHtml);
					}

					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = fullHtml;
					const plainText = tempDiv.innerText.trim();

					if (plainText.length > charLimit) {
						const shortText = plainText.substring(0, charLimit).trim() + '...';

						// vraćamo <br> gde treba
						$desc.html(shortText.replace(/\n/g, '<br>'));
						$desc.next('.testimonial-slider__read-more-btn').show();
					} else {
						$desc.html(fullHtml);
						$desc.next('.testimonial-slider__read-more-btn').hide();
					}
				});
			};

			applyReadMore();

			let resizeTimeout;
			$(window).on('resize', function() {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(applyReadMore, 200);
			});

			$('.testimonial-slider__read-more-btn').on('click', function() {
				const $desc = $(this).prev('.testimonial-slider__slider-box-inner-desc');
				const fullHtml = $desc.data('original-html');
				const $popup = $('#testimonialPopup');

				$popup.find('.testimonial-popup__text').html(fullHtml);
				$popup.fadeIn(200).css('display', 'flex');
				$('body').addClass('no-scroll');
			});

			$('.testimonial-popup__close, .testimonial-popup__overlay').on('click', function() {
				$('#testimonialPopup').fadeOut(200);
				$('body').removeClass('no-scroll');
			});

			$(document).on('keydown', function(e) {
				if (e.key === 'Escape') {
					$('#testimonialPopup').fadeOut(200);
					$('body').removeClass('no-scroll');
				}
			});
		}
	};

	testimonialSliderMain.init();
});
